import { apiClient } from '@/services/ApiClient.js'

export class RetailerStockInputService {
  getInputs(query) {
    return apiClient
      .get('retailer-stock-inputs', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getTotalRemainingStockCost(query) {
    return apiClient
      .get('retailer-stock-inputs/total-remaining-stock-cost', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getStockInput(stockId) {
    return apiClient
      .get('retailer-stock-inputs/' + stockId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  searchRetailer(query) {
    return apiClient
      .get('retailers/filtered-for-stock-input', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  create(params) {
    return apiClient
      .post('retailer-stock-inputs', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateRetailerStockInput(id, stockInput) {
    return apiClient
      .patch('retailer-stock-inputs/' + id, stockInput)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  deleteRetailerStockInput(id) {
    return apiClient
      .delete('retailer-stock-inputs/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getStatistics(stockId) {
    return apiClient
      .get('retailer-stock-inputs/' + stockId + '/statistics')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  exportStockInputs(query, withInvoices) {
    let url = withInvoices ? 'retailer-stock-inputs-with-invoices/export' : 'retailer-stock-inputs/export'

    return apiClient
      .get(url, {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  transferToRetailer(stockId, params) {
    return apiClient
      .post('retailer-stock-inputs/' + stockId + '/transfer-to-retailer', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getRemainingByUnit(stockId, productUnitId) {
    return apiClient
      .get(`retailer-stock-inputs/${stockId}/remaining-by-unit/${productUnitId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBaseStockUnitPrice(params) {
    return apiClient
      .post('retailer-stock-inputs/get-base-stock-unit-price', params)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  }

  getShortSaleItems(stockId) {
    return apiClient
      .get(`retailer-stock-inputs/${stockId}/short-sale-items`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  closeShortSales(stockId, retailerShortSales) {
    return apiClient
      .post(`retailer-stock-inputs/${stockId}/close-short-sale-items`, {
        retailer_short_sales: retailerShortSales
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createRetailerStockInputInvoice(stockId, params) {
    return apiClient
      .post(`retailer-stock-inputs/${stockId}/retailer-stock-input-invoices`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  editRetailerStockInputInvoice(stockId, params) {
    return apiClient
      .put(`retailer-stock-inputs/${stockId}/retailer-stock-input-invoices/${params.invoice_id}`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  deleteRetailerStockInputInvoice(params) {
    return apiClient
      .delete(`retailer-stock-inputs/${params.stockId}/retailer-stock-input-invoices/${params.invoiceId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getAvailableStockInputs(params) {
    return apiClient
      .post('retailer-stock-inputs/get-available-stocks-inputs-for-retailer-short-sales', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  closeShortSaleItemUsingMultipleStockInputs(retailerShortSaleIds, retailerStockInputIds) {
    return apiClient
      .post('retailer-stock-inputs/close-short-sale-item-for-multiple-stock-input', {
        retailer_short_sale_ids: retailerShortSaleIds,
        retailer_stock_input_ids: retailerStockInputIds
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
